module.exports = __webpack_public_path__ + "assets/images/10QL.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/10QL.png
// module id = 1286
// module chunks = 1